<template lang="pug">
	li.sidenav-menu__toggle-listitem
		a.sidenav-menu__button(:href='href') 
			slot
</template>
<script>
export default {
	props: {
		href: {
			required: true,
			type: String
		}
	}
}
</script>